export const PROFILE_MODULE_NAVID = {
  pedigrees: 'PEDIGREES',
  individuals: 'INDIVIDUALS',
  invites: 'INVITES',
  invitesAdmin: 'INVITES_ADMIN',
  orders: 'ORDERS',
  letters: 'LETTERS',
  savessfmts: 'SAVESSFMTS',
};

export const PROFILE_INTERFACE_TYPE = {
  fullClient: 0,
  dashboard: 1,
  patients: 2,
};